'use client';

import Image from "next/image";
import Link from "next/link";
import React from "react";
import { IAlternative } from "../../types";
import { StyledDiv } from "./alternativesCatalog.styles";

interface IAlternativesCatalogProps {
  alternatives: IAlternative[];
}

export const AlternativesCatalog = ({ alternatives = [] }: IAlternativesCatalogProps) => {
  const alternativeList = alternatives.sort((a, b) => a.order - b.order);

  return (
    <StyledDiv>
      <div className="platforms-container">
        {alternativeList.length > 0 &&
          alternativeList.map((alternative) => (
            <Link
              title={`Common Ninja VS ${alternative.name}`}
              href={`/alternatives/${alternative.slug}`}
              key={alternative.name}
              className="platform-card"
            >
              <div className="img-wrapper">
                <Image src={alternative.logo} alt={alternative.name} fill />
              </div>
            </Link>
          ))}
      </div>
    </StyledDiv>
  );
};
